import {clinicActions} from '../actionCreators';

const InitialPatientDetails={
    clinicListInfo:{total_items:0,items:[],hasClinic:false,current:null,map:{},page:1,page_size:10},
    selectedClinicId: "",
    clinicLocations: [],
    clinicDashboards: {},
    userInvitations: [],
    clinicUsers: [],
    clinicUsersMetrics: {
        total_entries: 0,
        expired_invites: 0,
        pending_invites: 0,
        cancelled_invites: 0,
        active_users: 0,
        deactivated_users: 0
    },
    clinicAccessRoles: [],
    platformPermissions: [],
    clinicAllRoles: [],
    dataImportHistoryList:[]
}

const clinicReducer=(state=InitialPatientDetails, action)=>{
    switch(action.type){
        case clinicActions.UPDATE_USER_CLINICS : {
            const st = {...state};
            st.selectedClinicId = action.payload.selectedClinicId || st.selectedClinicId;
            const clinicListInfo = {...st.clinicListInfo,...action.payload, hasClinic: action.payload.items.length > 0, current: null, map: action.payload.items?.toMap("clinic_id") || {}};
            st.selectedClinicId && (clinicListInfo.current = clinicListInfo.map[st.selectedClinicId])
            return {...st, clinicListInfo}
        }
        case clinicActions.UPDATE_USER_SELECTED_CLINIC : {
            const st = {...state};
            const clinicMap = st.clinicListInfo.map;
            st.clinicListInfo.current = clinicMap[action.payload] || null;
            return {...st, selectedClinicId : action.payload}
        }
        case clinicActions.UPDATE_CLINIC_LOCATIONS : {
            return {...state, clinicLocations : action.payload }
        }
        case clinicActions.UPDATE_DASHBOARDS_LIST : {
            return {...state, clinicDashboards : {...(action.reset?{}:state.clinicDashboards), ...(action.persistDefault && state.clinicDashboards[action.persistDefault]?{}:action.payload) } }
        }
        case clinicActions.UPDATE_USER_INVITATIONS : {
            return {...state, userInvitations : action.payload }
        }
        case clinicActions.UPDATE_CLINIC_USERS : {
            return {...state, clinicUsers : action.payload }
        }
        case clinicActions.UPDATE_CLINIC_USER_METRICS : {
            return {...state, clinicUsersMetrics : action.payload }
        }
        case clinicActions.UPDATE_CLINIC_LOGO : {
            const userClinics = [
                ...state.userClinics.map((item) => {
                    if(item.clinic_id === action.payload.clinicId) {
                      return {
                        ...item,  
                        logo: action.payload.logo
                      }
                    }
                    return item;
                  })
            ];
            const clinicMap = userClinics.toMap("clinic_id");
            return{...state, clinicLogo:action.payload.logo,userClinics,clinicMap,clinicInfo :clinicMap[action.payload.clinicId]}  
        }
        case clinicActions.UPDATE_CLINIC_ACCESS_ROLES : {
            return {...state, clinicAccessRoles : action.payload }
        }
        case clinicActions.UPDATE_PLATFORM_PERMISSIONS : {
            return {...state, platformPermissions : action.payload }
        }
        case clinicActions.UPDATE_CLINIC_ALL_ROLES : {
            return {...state, clinicAllRoles : action.payload }
        }
        case clinicActions.DATA_IMPORT_HISTORY_LIST : {
            return {...state, dataImportHistoryList : action.payload }
        }
        default:{
            return state
        }
    }
}

export default clinicReducer;